import React, { useEffect, useState } from "react";
import {  CircularProgress } from "@mui/material";
import SearchBar from "../Functionalities/SearchBar";
import ReportTable from "./ReportList";
import TablePagination from "../Functionalities/Pagination"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { post,get } from "../../../helpers/api_helper";

const SharedReports = () => {
  const [reports, setReports] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [loading, setLoading] = useState(true);
  const itemsPerPage = 10;

  useEffect(() => {
    const fetchData = async () => {
      try {
    
        const response = await get("/userReports");
     
        setReports(response || []);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  
  
  const filteredReports= reports.filter((report) =>
    report.productName.toLowerCase().includes(searchKeyword.toLowerCase())
  );
  let displayedReports = filteredReports;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = displayedReports.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleSearch = (e) => {
    const keyword = e.target.value.toLowerCase();
    setSearchKeyword(keyword);
    setCurrentPage(1);
  };
  
  return (
    <div className="m-4">
      <div>
        <h1 className="text-2xl font-semibold mb-4 ">
         Reports
        </h1>
        <SearchBar
          searchKeyword={searchKeyword}
          handleSearch={handleSearch}
          
        />
        {loading ? (
          <div className="flex justify-center">
            <CircularProgress />
          </div>
        ) : (
          <>
                   
          <ReportTable
            reports={reports}
            filteredProducts={filteredReports}
            currentItems={currentItems}
          />
         

        </>
        )}

      </div>
          <TablePagination
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          totalItems={filteredReports.length}
          onPageChange={handlePageChange}
        />
        <ToastContainer />
    </div>
  );
};

export default SharedReports;
